import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { scrollToCompra } from './utils/scroll';
const PainPointsSection = lazy(() => import('./components/PainPointsSection').then(m => ({
  default: m.PainPointsSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  // Meta Pixel
  useEffect(() => {
    const PIXEL_ID = '1858642644845675';
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
      // noscript fallback pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 800) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen font-sans text-[#111111] bg-white selection:bg-[#C4A7E7] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <PainPointsSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <TomosSection data-id="element-5" />
        <BonusesSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FooterSection data-id="element-11" />
        <SocialProofPopup data-id="element-12" />
      </Suspense>

      <AnimatePresence data-id="element-13">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-14">
            <button onClick={scrollToCompra} className="w-full bg-[#22C55E] hover:bg-[#16a34a] text-white font-bold py-4 px-4 rounded-full shadow-lg flex items-center justify-center gap-2" data-id="element-15">
              ✅ QUIERO EL MEGA KIT HOY
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}